@if (variant === "secondary") {
  <button
    mat-stroked-button
    class="shared-action shared-action--secondary"
    [class.shared-action--full-width]="fullWidth"
    [type]="type"
    [disabled]="disabled || loading"
    [attr.aria-label]="ariaLabel"
    [attr.aria-busy]="loading ? 'true' : 'false'"
    (click)="pressed.emit($event)"
  >
    <ng-container *ngTemplateOutlet="loadingIndicator"></ng-container>
    <ng-container *ngTemplateOutlet="label"></ng-container>
  </button>
} @else {
  <button
    mat-raised-button
    [color]="variant === 'destructive' ? 'warn' : 'primary'"
    class="shared-action"
    [class.shared-action--primary]="variant === 'primary'"
    [class.shared-action--add]="variant === 'add'"
    [class.shared-action--destructive]="variant === 'destructive'"
    [class.shared-action--full-width]="fullWidth"
    [type]="type"
    [disabled]="disabled || loading"
    [attr.aria-label]="ariaLabel"
    [attr.aria-busy]="loading ? 'true' : 'false'"
    (click)="pressed.emit($event)"
  >
    @if (variant === "add") {
      <mat-icon class="shared-action__icon" aria-hidden="true">add</mat-icon>
    }
    <ng-container *ngTemplateOutlet="loadingIndicator"></ng-container>
    <ng-container *ngTemplateOutlet="label"></ng-container>
  </button>
}

<ng-template #label><ng-content></ng-content></ng-template>
<ng-template #loadingIndicator>
  <mat-progress-spinner
    class="shared-action__spinner"
    [class.shared-action__spinner--visible]="loading"
    [diameter]="16"
    [strokeWidth]="3"
    mode="indeterminate"
    aria-hidden="true"
  ></mat-progress-spinner>
</ng-template>
